module.exports = __webpack_public_path__ + "img/lt.149bce1c.png";